import request from 'superagent'
import store from '../../redux/store'
import * as AuthActions from '../../redux/auth/actions'
// import { push } from 'connected-react-router'

// Build time может прилететь env с установкой желаймого stage (production, staging, development)
// по дефолту смотрим на production
// локально для запуска нужного окружения удобно юзать REACT_APP_SARAFAN_STAGE=staging yarn start
export const stage = process.env.REACT_APP_SARAFAN_STAGE ? process.env.REACT_APP_SARAFAN_STAGE : 'staging'

const TIMEOUT_RESPONSE = 60000
const TIMEOUT_DEADLINE = 60000

const API_URLS = {
  production: `https://api.sarafan-app.ru`,
  staging: `https://api-staging.sarafan-app.ru`,
  development: ``,
}
export const API_URL = `${API_URLS[stage]}/admin-api`

const API_ENDPOINTS = {
  login:            `${API_URL}/auth/login`,
  profile:          `${API_URL}/auth/profile`,
  logout:           `${API_URL}/auth/logout`,
  usersList:        `${API_URL}/users/list/{name_prefix}`,
  usersDetails:     `${API_URL}/users/details/{id}`,
  usersEdit:        `${API_URL}/users/edit`,
  analyticsList:    `${API_URL}/analytics/list`,
  analyticsEdit:    `${API_URL}/analytics/edit`,
  clientFunnel:     `${API_URL}/analytics/funnels/client`,
  proFunnel:        `${API_URL}/analytics/funnels/pro`,
  topProLinks:      `${API_URL}/analytics/funnels/top-prolinks`,
  statistic:        `${API_URL}/analytics/funnels/statistic`,
  skillsList:       `${API_URL}/skills/list`,
  ordersList:       `${API_URL}/orders/list`,
  verifyOrder:      `${API_URL}/orders/verify`,
  cancelOrder:      `${API_URL}/orders/cancel`,
}

export default class SarafanApiClient {
  static handleErrors(error: request.Response) {
    // ResponseHandler.handleResponse(response)

    console.log("global sarafan api error handler:");
    console.log(error);
    if (error.status === 400 &&
      typeof(error.response.body) === 'object' &&
      typeof(error.response.body.error) === 'object' &&
      error.response.body.error.error_code === 'unauthorized')
    {
      console.log('unauthorized error received. logout user.')
      console.log(error.response.body)
      store.dispatch(AuthActions.logout())
      // store.dispatch(push('/login'))
    }
  }

  static handleResponse(response: request.Response) {
    console.log("global response handler: " + response.status)

  }

  static postRequest(endpoint: string, body = {}, headers = {}) {
    const head = {
      ...headers,
      'Sarafan-Admin-Access-Token': store.getState().auth.access_token,
    }
    return request
      .post(endpoint)
      .timeout({ response: TIMEOUT_RESPONSE, deadline: TIMEOUT_DEADLINE })
      .set(head)
      .send(body)
      .accept('application/json')
      .on('response', this.handleResponse)
      .on('error', this.handleErrors)
  }

  static getRequest(endpoint: string, body = {}, headers = {}) {
    const head = {
      ...headers,
      'Sarafan-Admin-Access-Token': store.getState().auth.access_token,
    }
    return request
      .get(endpoint)
      .timeout({ response: TIMEOUT_RESPONSE, deadline: TIMEOUT_DEADLINE })
      .query(body)
      .set(head)
      .accept('application/json')
      .on('response', this.handleResponse)
      .on('error', this.handleErrors)
  }

  static login({ email, password }: { email: string, password: string }) {
    const endpoint = API_ENDPOINTS.login
    const body = {
      email: email,
      password: password
    }

    return this.postRequest(endpoint, body)
  }

  static profile() {
    const endpoint = API_ENDPOINTS.profile

    return this.getRequest(endpoint, {})
  }

  static logout() {
    const endpoint = API_ENDPOINTS.logout

    return this.postRequest(endpoint, {})
  }

  static usersList(namePrefix) {
    const endpoint = API_ENDPOINTS.usersList.replace('{name_prefix}', encodeURIComponent(namePrefix))

    return this.getRequest(endpoint, {})
  }

  static usersDetails(id) {
    const endpoint = API_ENDPOINTS.usersDetails.replace('{id}', id)

    return this.getRequest(endpoint, {})
  }

  static usersEdit(userData) {
    const endpoint = API_ENDPOINTS.usersEdit

    return this.postRequest(endpoint, userData)
  }

  static analyticsList() {
    const endpoint = API_ENDPOINTS.analyticsList

    return this.getRequest(endpoint, {})
  }

  static analyticsEdit(eventData) {
    const endpoint = API_ENDPOINTS.analyticsEdit

    return this.postRequest(endpoint, eventData)
  }

  static clientFunnel() {
      const endpoint = API_ENDPOINTS.clientFunnel

      return this.getRequest(endpoint, {})
  }

  static proFunnel() {
      const endpoint = API_ENDPOINTS.proFunnel

      return this.getRequest(endpoint, {})
  }

  static topProLinks() {
      const endpoint = API_ENDPOINTS.topProLinks

      return this.getRequest(endpoint, {})
  }

  static statistic() {
      const endpoint = API_ENDPOINTS.statistic

      return this.getRequest(endpoint, {})
  }

  static skillsList() {
    const endpoint = API_ENDPOINTS.skillsList

    return this.getRequest(endpoint, {})
  }

  static ordersList() {
      const endpoint = API_ENDPOINTS.ordersList

      return this.getRequest(endpoint, {})
  }

  static verifyOrder(orderData) {
      const endpoint = API_ENDPOINTS.verifyOrder

      return this.postRequest(endpoint, orderData)
  }

  static cancelOrder(orderData) {
      const endpoint = API_ENDPOINTS.cancelOrder

      return this.postRequest(endpoint, orderData)
  }
}



// WEBPACK FOOTER //
// ./src/services/SarafanApiClient/index.js